import React from 'react';
import { RouteComponentProps } from '@reach/router';
import FullPage from '../../../layouts/FullPage';

// TODO: Import components

interface IMoneyReportPageProps extends RouteComponentProps { }

interface IState { }

class MoneyReportPage extends React.Component<IMoneyReportPageProps, IState> {
    // Define the constructor for the money report page
    constructor (props: IMoneyReportPageProps) {
        // Pull in parent props
        super(props);
    }

    // TODO: When the component mounts
    componentDidMount () {
    }

    // Render the TSX for the money report container
    render () {
        return (
            <FullPage>
                <section className="section" style={{ paddingTop: '1rem' }}>
                    <div className="container">
                        <nav className="navbar navbar-expand-lg navbar-dark flex-column shadow-2 bg-white">
                            <div className="container d-stick-none">
                                <div className="navbar-left">
                                    <button className="navbar-toggler" type="button"><span className="navbar-toggler-icon"></span></button>
                                    <span className="nav-link fw-600">Company Name, Project Name</span>
                                </div>

                                <section className="navbar-mobile">
                                    <nav className="nav nav-navbar ml-auto">
                                        <span className="nav-link">Money Report</span>
                                    </nav>
                                </section>
                            </div>
                        </nav>
                    </div>
                </section>

                <section className="section" style={{ paddingTop: '0rem' }}>
                    <div className="container pl-0 pr-0">
                        {/* TODO: Add functionality and remove warning */}
                        <div className="alert alert-warning" role="alert">Money report is not yet functional</div>

                        {/*
                            TBD
                        */}
                    </div>
                </section>
            </FullPage>
        );
    }
}

export default MoneyReportPage;
